import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var LastName = /*#__PURE__*/function () {
  function LastName() {
    _classCallCheck(this, LastName);
  }

  _createClass(LastName, null, [{
    key: "isValid",
    value: function isValid(value) {
      var isOnValidLength = value.length >= this.minLength && value.length <= this.maxLength;
      return isOnValidLength;
    }
  }]);

  return LastName;
}();

_defineProperty(LastName, "maxLength", 20);

_defineProperty(LastName, "minLength", 2);